import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import {NavLink, Link} from 'react-router-dom';
import Statement from './Finance/Statement';
import Structure from './Finance/Structure';
import { HashRouter, Route, Switch} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'


class Finance extends Component {

    constructor(props) {
        super(props);


         this.state={
          user_details:this.props.user_details,
          access_token:this.props.access_token,
         }
    }


  render() {
    const _this=this;

    return (
      <div className="main-panel">

        <Header title = "Finance" />


        <div className="content-inner">
            <div className="container-fluid">
                <div className="row">
                    <ul className="nav nav-pills nav-pills-warning" role="tablist">


                            <li className="nav-item">
                            <Link className="nav-link" to="/student_ui/finance/statement" role="tablist">
                                FEES STATEMENT
                            </Link>
                            </li>

                            <li className="nav-item">
                            <Link className="nav-link "  to="/student_ui/finance/structure" role="tablist">
                                FEES STRUCTURE
                            </Link>
                            </li>

                    </ul>
                </div>

                <div className ="row full-width">
                    <Switch>
                        < Route
                                exact path="/student_ui/finance"
                                render={(props) => <Statement {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          renderInThousands = {this.props.renderInThousands}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />
                        <Route
                                exact path="/student_ui/finance/structure"
                                render={(props) => <Structure {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          renderInThousands = {this.props.renderInThousands}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />
                         <Route
                                exact path="/student_ui/finance/statement"
                                render={(props) => <Statement {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          renderInThousands = {this.props.renderInThousands}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />

                    </Switch>
                </div>

            </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default Finance;
